import { useState } from 'react'
import { Link, usePage } from '@inertiajs/react'
import { cn } from '@/lib/utils'
import { Sheet, SheetContent, SheetTitle, SheetTrigger } from '@/components/ui/sheet'
import { CTAButton } from './CTAButton'
import { mainNavItems, contactInfo } from './navigation-config'

export function MobileNav() {
  const [open, setOpen] = useState(false)
  const { url } = usePage()
  // Inertia's usePage().url is path+query; strip the query string so active-link
  // matching works on filtered routes (e.g. /bikes?category=family → /bikes).
  const currentPath = url.split('?')[0]

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger asChild>
        <button
          className="md:hidden"
          aria-label="Open menu"
          aria-expanded={open}
          data-testid="mobile-nav-toggle"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <line x1="4" y1="6" x2="20" y2="6" />
            <line x1="4" y1="12" x2="20" y2="12" />
            <line x1="4" y1="18" x2="20" y2="18" />
          </svg>
        </button>
      </SheetTrigger>

      <SheetContent side="right" data-testid="mobile-nav-menu" className="p-6 w-[300px] sm:w-[350px] sm:max-w-[350px]">
        {/* Accessible dialog title — visible branded wordmark doubles as the dialog's
            accessible name (Radix Dialog requires a Title for screen readers). */}
        <SheetTitle className="mb-8 mt-6 text-base font-normal">
          <span className="text-foreground">Front Range</span>
          <span className="ml-1 text-primary">Cargo Bikes</span>
        </SheetTitle>

        <nav className="mt-8 flex flex-col gap-4" aria-label="Mobile main">
          {mainNavItems.map((item) => (
            <Link
              key={item.href}
              href={item.href}
              onClick={() => setOpen(false)}
              aria-current={currentPath === item.href ? 'page' : undefined}
              className={cn(
                'text-lg font-medium transition-colors hover:text-primary py-2',
                currentPath === item.href ? 'text-primary' : 'text-muted-foreground'
              )}
            >
              {item.label}
            </Link>
          ))}
        </nav>

        <div className="mt-8 pt-8 border-t">
          <CTAButton href="/book" size="lg" className="w-full">
            Book a free test ride
          </CTAButton>
        </div>

        <div className="mt-8 pt-8 border-t space-y-3 text-sm text-muted-foreground">
          <p className="flex items-center gap-2">
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z" />
              <circle cx="12" cy="10" r="3" />
            </svg>
            {contactInfo.address}
          </p>
          <p className="flex items-center gap-2">
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z" />
            </svg>
            {contactInfo.phone}
          </p>
          <p className="flex items-center gap-2">
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <circle cx="12" cy="12" r="10" />
              <polyline points="12,6 12,12 16,14" />
            </svg>
            {contactInfo.hours}
          </p>
        </div>
      </SheetContent>
    </Sheet>
  )
}
